module.exports = __webpack_public_path__ + "static/media/PlanOpSim_SOLO.c79fe4b3.png";